import { observer } from 'mobx-react-lite'
import { MobileImageButtons } from '../../MobileImageButtons/MobileImageButtons'
import { StockVideos } from './StockVideos'
import { Uploads } from './Uploads'
import { StockPhotos } from './StockPhotos'
import Styles from './UploadsDrawer.module.scss'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { BrandKit } from './BrandKit'
import { Basics } from './Basics'
import { useUploadsTab } from '../UploadsTabContext'

export const DefaultPanel = observer(() => {
  const { data } = useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.media_files.length > 0),
    cacheTime: 1000 * 60 * 5,
  })

  const { forBackground } = useUploadsTab()

  return (
    <div className={Styles.defaultContainer}>
      {!forBackground && <MobileImageButtons />}
      <Uploads />
      {data?.map((brandKit) => (
        <BrandKit key={brandKit.id} brandKit={brandKit} />
      ))}
      {!forBackground && <StockVideos />}
      <StockPhotos />
      {!forBackground && <Basics />}
    </div>
  )
})
